import React from "react";
import BlueMascot from "./BlueMascot";

/**
 * BlueChatButton — état "fermé" du chat.
 * Affiche Blue en petit avec une bulle d'invitation discrète.
 */
export function BlueChatButton({ config, onOpen, unreadIntro }) {
  return (
    <button
      type="button"
      className="blue-chat-button"
      onClick={onOpen}
      aria-label={config.strings.openLabel}
      data-testid="blue-chat-open-button"
    >
      {config.showTagline && (
        <span className="blue-chat-button__tagline" data-testid="blue-chat-tagline">
          {config.tagline}
          <span className="blue-chat-button__arrow" aria-hidden="true" />
        </span>
      )}
      <span className="blue-chat-button__mascot">
        <BlueMascot state="idle" variant="portrait" size={72} />
        {unreadIntro && (
          <span className="blue-chat-button__dot" aria-hidden="true" />
        )}
      </span>
    </button>
  );
}

export default BlueChatButton;
